require('./hireCreditCardStep5.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const { formatAmountObject, formatAmount } = require('utilities/currencyHelper');
const PersonalDataHelper = require('utilities/personalDataHelper');
const { contactCenterClassName } = require('utilities/conditionals/conditionalClassname');
const { openBase64pdfInPrintWindow } = require('utilities/pdfDocumentsHelper');
const { downloadAsFile, base64ToBlob } = require('utilities/APIRequestHelper');
const getExtension = require('utilities/mimeTypeToExt');

//@commons
const { OKConsents } = require('gdpr-consents/components/OKConsents/OKConsents.js');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');

// @components
const { GDPRSignaturePattern } = require('components/gdprSignaturePattern/gdprSignaturePattern');

const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const {
    ConfirmationScript,
    CONFIRMATION_SCRIPT_GREETING,
    CONFIRMATION_SCRIPT_AGREEMENT
} = require('components/contactCenter/confirmScript/confirmationScript');
const WebappRender = require('components/conditionalRender/webappRender')
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
const ContactCenterNewValidationCards = require('components/hire/contactCenterValidationCards/contactCenterNewValidationCards');

const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

// @constants
const {
    CARD_PAYMENT_METHOD_UNIQUE,
    CARD_PAYMENT_METHOD_FIXED,
    CARD_PAYMENT_METHOD_VARIABLE,
    EURO_SYMBOL,
    EURO_TEXT,
    FIFTH_STEP,
    HYPHEN,
} = require('constants/index');
const {
    MULTIPLE_OPERATIONS,
    messages: { NERUDA_HIRE_AND_GDPR, DIAMOND_PACK_AND_GDPR }
} = require('constants/operationTypes');
const {
    HORMIGUERO_CARD_PRODUCT_NAME,
    NERUDA_CARD_PRODUCT_NAME,
    VANITY_CARD_PRODUCT_NAME,
} = require('constants/cardsPrecontractualMailInfo');
const { OKPdfViewer } = require('commonsComponents/OKPdfViewer');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const { NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES } = require('constants/flagBasedFeatures');
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');

class HireCreditCardStep5 extends React.Component {
    constructor(props) {
        super(props);
        this.handleDownloadPdf = this.handleDownloadPdf.bind(this);
        this.handleOnPrint = this.handleOnPrint.bind(this);
        this.handleDocumentReaded = this.handleDocumentReaded.bind(this);
        this.handleYesNoSignedDocuments = this.handleYesNoSignedDocuments.bind(this)
        const { cardType, hireCreditCard } = this.props;

        let productName = '';

        if (cardType === 'vanity') {
            productName = VANITY_CARD_PRODUCT_NAME;
        } else if (cardType === 'neruda') {
            productName = NERUDA_CARD_PRODUCT_NAME;
        } else if (cardType === 'hormiguero') {
            productName = HORMIGUERO_CARD_PRODUCT_NAME;
        }

        this.state = {
            precontractualMailProductInfo: {
                productName,
                producto: hireCreditCard.get('type'),
                standard: hireCreditCard.get('standard'),
                subproducto: hireCreditCard.get('subtype'),
            }
        };
    }

    componentDidMount() {
        const {
            getContextTranslate,
            sendPrecontractualDocumentMail,
            setTermsAndCondsText,
            showIneAndRevolving
        } = this.props;

        const { precontractualMailProductInfo } = this.state;

        if (!showIneAndRevolving) {
            sendPrecontractualDocumentMail(precontractualMailProductInfo);
            if (!__CONTACT_CENTER__) {
                //This action is also called in the first step of the current hiring, if you update one remeber that maybe you should update the other one
                setTermsAndCondsText(getContextTranslate('confirmationStepAgreementText'));
            }
        }
    }

    onHandleChangeCheckBox = (evt) => {
        const { handleAgreementCheckboxChange } = this.props;
        return handleAgreementCheckboxChange(evt, FIFTH_STEP)
    }

    onHandleChangeCheckBoxCC = (evt) => {
        const { handleAgreementCheckboxChange } = this.props;
        return handleAgreementCheckboxChange(evt, FIFTH_STEP)
    }

    buildLegalConfirmationSection(showRevolvingDocument, amount) {
        const {
            contractName,
            getContextTranslate,
            hireCreditCard,
            sendMailParams,
            showIneAndRevolving,
            onHandleChangeCheckBoxCC,
            immFlagBasedFeatures,
            processEmail
        } = this.props;
        const { precontractualMailProductInfo } = this.state;
        const newCardsFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES);
        const immStep = hireCreditCard.getIn(['steps', FIFTH_STEP]);
        const agreementLabel = <FormattedText value={getContextTranslate('step4NewCheckboxText')} />;
        const agreementErrorMsg = formatText(getContextTranslate('step4CheckboxErrorMsg'));
        const documentINE = hireCreditCard.get('documentINE')
        const documentPolicy = hireCreditCard.get('documentPolicy')
        const newIntLoading = documentINE && documentPolicy
        return (
            <ContactCenterNewValidationCards
                amount={amount}
                agreementErrorMsg={agreementErrorMsg}
                agreementLabel={agreementLabel}
                contractName={contractName}
                handleAgreementCheckboxChange={this.onHandleChangeCheckBox}
                isContractingProcess
                immStep={immStep}
                precontractualMailProductInfo={precontractualMailProductInfo}
                sendMailParams={sendMailParams}
                showIneAndRevolving={showIneAndRevolving}
                showRevolvingDocument={showRevolvingDocument}
                processEmail={processEmail}
                immHireCardOpenCredit={hireCreditCard}
                onHandleChangeCheckBoxCC={onHandleChangeCheckBoxCC}
                ineNotCall={newCardsFF}
                newIntLoading={newIntLoading}
                newCardsFF={newCardsFF}
            />
        )

    }
    handleYesNoSignedDocuments(value) {
        const { printedAndSignedRadioChanged, enableButtonOffice, checkRadioButtonPolicy } = this.props

        checkRadioButtonPolicy(value === 'yes' ? true : false)
        printedAndSignedRadioChanged(value)
        enableButtonOffice();
    }

    buildSummary() {
        const {
            getContextTranslate,
            immHireCardNameSelector,
            immHireCreditLimit,
            immHirePaymentMethod,
            immProfile,
        } = this.props;

        const limitObj = {
            amount: immHireCreditLimit.get('creditLimit'),
            currency: EURO_TEXT
        };

        const paymentMethod = {
            [CARD_PAYMENT_METHOD_UNIQUE]: `${formatText('hireCardOpenCredit-summaryMethodOfPaymentFullPay')}`,
            [CARD_PAYMENT_METHOD_FIXED]: `${formatText('hireCardOpenCredit-summaryMethodOfPaymentDeferredFixedFee')}`,
            [CARD_PAYMENT_METHOD_VARIABLE]: `${formatText('hireCardOpenCredit-summaryMethodOfPaymentDeferredVariableFee')}`
        };

        const paymentMethodType = immHirePaymentMethod.get('type');
        const paymentMethodText = paymentMethod[paymentMethodType];
        const paymentMethodSymbol = paymentMethodType === CARD_PAYMENT_METHOD_FIXED ? EURO_SYMBOL : '%';
        const paymentMethodValue = paymentMethodType === CARD_PAYMENT_METHOD_UNIQUE
            ? paymentMethodText
            : `${paymentMethodText} ${formatAmount(immHirePaymentMethod.get('value'), getLanguage(), 0)} ${paymentMethodSymbol}`;

        const addressValue = immProfile.get('isFetching') ? HYPHEN : PersonalDataHelper.getHireFormattedAddress(immProfile);

        return (
            <div className="hire-card-neruda-step-five__summary row">
                <div className="col-xs-6 print-label">
                    <div className="hire-card-neruda-step-five__summary-label">
                        <FormattedText value={getContextTranslate('summarySelectedName')} />
                    </div>
                    <div className="hire-card-neruda-step-five__summary-value">
                        {immHireCardNameSelector.getIn(['names', immHireCardNameSelector.get('selectedIndex')])}
                    </div>
                </div>
                <div className="col-xs-6">
                    <div className="hire-card-neruda-step-five__summary-label">
                        <FormattedText value={getContextTranslate('summarySelectedLimit')} />
                    </div>
                    <div className="hire-card-neruda-step-five__summary-value--highlight">
                        <OneLineSymbolAmount
                            amountObject={limitObj}
                            amountObjectFormatted={formatAmountObject(limitObj, true)}
                            language={getLanguage()}
                            trimDecimals={true}
                        />
                    </div>
                </div>
                <div className="col-xs-6 print-label">
                    <div className="hire-card-neruda-step-five__summary-label">
                        <FormattedText value={getContextTranslate('summaryPaymentMethod')} />
                    </div>
                    <div className="hire-card-neruda-step-five__summary-value">
                        {paymentMethodValue}
                    </div>
                </div>
                <div className="col-xs-6">
                    <div className="hire-card-neruda-step-five__summary-label">
                        <FormattedText value={getContextTranslate('summaryShippingAddress')} />
                    </div>
                    <div className="hire-card-neruda-step-five__summary-value">
                        {addressValue}
                    </div>
                </div>
            </div>
        );
    }

    blockInfo() {
        const { operativeName } = this.props;
        return (

            <BlockInfo extraClass="contract-payroll-loan-step-two__block-check block-info" hasCheckbox>
                <ContactCenterRender>
                    <ConfirmationScript
                        operative={formatText(operativeName)}
                        confirmationType={CONFIRMATION_SCRIPT_GREETING}
                    />
                </ContactCenterRender>
            </BlockInfo>
        );
    }
    openPdfInNewTab(documentKey) {
        const { hireCreditCard } = this.props;
        const document = hireCreditCard.get(documentKey);
        const contentType = "application/pdf";
        const pdf = `data:${contentType};base64,${document}`;
        if (document) {
            openBase64pdfInPrintWindow(pdf, true);
        }
    }

    handleOpenPdfINENewTab() {
        this.openPdfInNewTab('documentINE');
    }

    handleOpenPdfDIRNewTab() {
        this.openPdfInNewTab('documentDIR');
    }

    buildPdfLink() {
        const { hireCreditCard } = this.props;
        const documentDIR = hireCreditCard.get('documentDIR');
        return (
            <>
                <div>
                    <h4 className="contract-loan-pdf-viewer__subtitle">
                        <strong>
                            <FormattedText value={`overdraftProtectionLoan-subtitleConfirmPage`} />
                        </strong>
                    </h4>
                    <div className="contract-actions-readed contract-payrollLoan-readed">
                        <button className="link--red option-link-cards-color-blue" onClick={() => this.handleOpenPdfINENewTab()}>
                            <FormattedText value={'hireCardOpenCredit-hireCardOpenCredit_legalText'} />
                        </button>
                        <span>
                            <i className="signature-pattern-code-input__icon icon icon-check " />
                            <FormattedText className="signature-text" value={'hireCardOpenCredit-hireCardOpenCredit_legalTextRead'} />
                        </span>
                    </div>
                    {documentDIR && (
                        <div className="contract-actions-readed contract-payrollLoan-readed">
                            <button className="link--red option-link-cards-color-blue" onClick={() => this.handleOpenPdfDIRNewTab()}>
                                <FormattedText value={'hireCreditCard-documentNameDir'} />
                            </button>
                            <span>
                                <i className="signature-pattern-code-input__icon icon icon-check" />
                                <FormattedText className="signature-text" value={'hireCardOpenCredit-hireCardOpenCredit_legalTextRead'} />
                            </span>
                        </div>
                    )}
                </div>

            </>
        )
    }
    handleOnPrint() {
        const { hireCardNerudaPrintDocument, hireCreditCard, hireCardNerudaPrintDocumentPolicy } = this.props;
        const documentINE = hireCreditCard.get('documentPolicy');
        if (documentINE) {
            const base64 = documentINE;
            const contentType = "application/pdf";
            const pdf = `data:${contentType};base64,${base64}`;
            const data = [base64ToBlob(pdf)];
            const blobObject = new Blob(data, { type: `${contentType};base64` });
            const blobURL = URL.createObjectURL(blobObject);
            const winparams = `dependent=yes,locationbar=no,scrollbaars=yes,menubar=yes,resizable,screenX=50,screenY=50,width=${screen.width},height=${screen.height}`;
            const printWindow = window.open(blobURL, '', winparams);
            isPrintOfficeMode() ? hireCardNerudaPrintDocumentPolicy() : hireCardNerudaPrintDocument()
            if (printWindow) {
                printWindow.print();
            }

        }
    }
    handleDocumentReaded() {
        const { cardsConfimationScrollDownPolicy } = this.props;
        cardsConfimationScrollDownPolicy();
    }

    handleDownloadPdf() {
        const { hireCreditCard } = this.props;
        const documentINE = hireCreditCard.get('documentPolicy');
        const base64 = documentINE;
        const contentType = "application/pdf";
        const pdf = `data:${contentType};base64,${base64}`;
        let fileName = formatText(`hireCardOpenCreditStepPolicy-pdfDownload`) + "." + getExtension(contentType);
        downloadAsFile(base64ToBlob(pdf), contentType, fileName);

    }
    buildViewer() {
        const { hireCreditCard } = this.props;

        const documentINE = hireCreditCard.get('documentPolicy');
        if (documentINE) {
            let title = formatText(`hireCardOpenCreditStepPolicy-titlePdfWP`);
            const scale = 1.05;
            const viewerHeight = 480;
            const base64 = documentINE;
            const contentType = "application/pdf";
            const document = `data:${contentType};base64,${base64}`;

            return (
                <OKPdfViewer
                    onDownload={this.handleDownloadPdf}
                    pdfFile={document}
                    scale={scale}
                    viewerHeight={viewerHeight}
                    onPrint={this.handleOnPrint}
                    title={title}
                    showScroll
                    onScroll={this.handleOnScroll}
                    onDocumentReaded={this.handleDocumentReaded}
                />
            );
        } else {
            return <LoadingSection />;
        }
    }
    blockInfoOffice() {
        return (
            <BlockInfo extraClass="contract-payroll-loan-step-two__block-check hire-card-open-credit-step-five__block-info-officine" hasCheckbox>
                <strong><FormattedText value="hireCardOpenCreditStep5-blockInfoOficineTitle" /></strong>
                <br />
                <br />
                <FormattedText value="hireCardOpenCreditStep5-blockInfoOficineSubTitle" />
            </BlockInfo>
        );
    }
    buildRadioButton() {
        const { hireCreditCard } = this.props;
        const cardsDocumentsPrintedAndSignedPolicy = hireCreditCard.get('cardsDocumentsPrintedAndSignedPolicy');
        return (
            <div className="mortgage-request-holder-radio-button">
                <p>{formatText(`hireCardtStep-titleOfficeRadio`)}</p>
                <RadioButtonGroup
                    onChange={this.handleYesNoSignedDocuments}
                    selectedValue={cardsDocumentsPrintedAndSignedPolicy === null ? '' : (cardsDocumentsPrintedAndSignedPolicy ? 'yes' : 'no')}
                    idPrefix="newRadioPrintedDocument"
                    isHorizontal={false}
                    name="newRadioPrintedDocument">
                    <RadioButton label={formatText('officePrinter-yesRadioOption')} value={'yes'} className="signature-pattern__printed-documents-radio" />
                    <RadioButton label={formatText('officePrinter-noRadioOption')} value={'no'} className="signature-pattern__printed-documents-radio" />
                </RadioButtonGroup>
            </div>
        )
    }

    render() {
        const {
            getContextTranslate,
            handleAgreementCheckboxChange,
            hireCreditCard,
            immHireCreditLimit,
            immHirePaymentMethod,
            immPdfData,
            operativeName,
            showIneAndRevolving,
            immFlagBasedFeatures,
            placementIdCard,
            serviceCodes
        } = this.props;
        const allDocumentRead = hireCreditCard.get('allDocumentRead')
        const newCardsFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES);
        const immStep = hireCreditCard.getIn(['steps', FIFTH_STEP]);
        const agreementLabel = <FormattedText value={getContextTranslate('confirmationStepAgreementText')} />;
        const agreementChecked = (__CONTACT_CENTER__ && !showIneAndRevolving ? true : immStep.get('agreementChecked'));
        const agreementErrorVisible = immStep.get('agreementIsDirty') && !immStep.get('agreementChecked');
        const agreementErrorMsg = formatText(getContextTranslate('step5CheckboxErrorMsg'));
        const pdfError = immPdfData.get('errorContent');
        const operationProcessId = hireCreditCard.get('operationProcessIdInitPolicy')
        const summaryContent = this.buildSummary();
        const hireCardTitleClassName = contactCenterClassName('print-title', 'hire-card-neruda-step-five__title');
        const hireCardSubTitleClassName = contactCenterClassName('print-paragraph', 'hire-card-neruda-step-five__subtitle');
        let agreementCheckboxContent, GDPRSignaturePatternContent;
        const paymentMethodType = immHirePaymentMethod.get('type');
        const showRevolvingDocument = paymentMethodType !== CARD_PAYMENT_METHOD_UNIQUE;
        const amount = immHireCreditLimit.get('creditLimit');
        const legalConfirmationSection = this.buildLegalConfirmationSection(showRevolvingDocument, amount);
        const blockInfo = isPrintOfficeMode() && this.blockInfo();
        const agreeIneCheckbox = hireCreditCard.get('agreeIneCheckbox')
        const pdfLink = newCardsFF ? this.buildPdfLink() : null
        const PDFDcocument = this.buildViewer();
        const blockInfoOffice = isPrintOfficeMode() ? this.blockInfoOffice() : null;
        if (!pdfError && !showIneAndRevolving) {
            agreementCheckboxContent = (
                <div className="hire-card-neruda-step-five__checkbox-container">
                    <WebappRender>
                        <OKCheckbox
                            idName="hireCardNerudaAgreementCheckbox"
                            errorState={agreementErrorVisible}
                            errorMessage={agreementErrorMsg}
                            label={agreementLabel}
                            onChange={handleAgreementCheckboxChange}
                            value={agreementChecked}
                        />
                    </WebappRender>
                </div>
            );
        }

        if (agreementChecked || !allDocumentRead) {
            GDPRSignaturePatternContent = (
                <GDPRSignaturePattern
                    operationType={MULTIPLE_OPERATIONS}
                    operationParams={serviceCodes}
                    multiOTPMessageCode={NERUDA_HIRE_AND_GDPR}
                    newOperationProcessId={operationProcessId}
                />
            );
        }

        if (agreeIneCheckbox || !allDocumentRead) {
            GDPRSignaturePatternContent = (
                <GDPRSignaturePattern
                    operationType={MULTIPLE_OPERATIONS}
                    operationParams={serviceCodes}
                    multiOTPMessageCode={DIAMOND_PACK_AND_GDPR}
                    newOperationProcessId={operationProcessId}
                    isEasyLoanTypeAB={isPrintOfficeMode() && true}
                />


            )
        }
        if (__CONTACT_CENTER__ && isPrintOfficeMode()) {
            return (
                <article className="hire-card-neruda-step-five">
                    <FormattedText
                        className={hireCardTitleClassName}
                        value="hireCardOpenCredit-step4Title"
                    />
                    <FormattedText
                        className={hireCardSubTitleClassName}
                        value="hireCardOpenCredit-step4Subtitle"
                    />
                    <br />
                    {summaryContent}
                    <OKConsents placementId={placementIdCard} />
                    <div className="hire-card-neruda-step-five__pdf-viewer-container">
                        {pdfLink}
                        <br />
                        <div className="hire-card-open-credit-step-five__summary-label">
                            <FormattedText value="hireCardOpenCredit-infoLink" />
                        </div>
                        <br />

                        {blockInfoOffice}
                        <br />

                        {PDFDcocument}
                    </div>
                    {GDPRSignaturePatternContent}
                </article>
            );
        } else {
            return (
                <article className="hire-card-neruda-step-five">
                    <FormattedText
                        className={hireCardTitleClassName}
                        value="hireCardOpenCredit-step4Title"
                    />
                    <ContactCenterRender>
                        <ConfirmationScript
                            operative={formatText(operativeName)}
                            confirmationType={CONFIRMATION_SCRIPT_GREETING}
                        />
                    </ContactCenterRender>
                    <FormattedText
                        className={hireCardSubTitleClassName}
                        value="hireCardOpenCredit-step4Subtitle"
                    />
                    {blockInfo}
                    <br />
                    {summaryContent}
                    <OKConsents placementId={placementIdCard} />
                    <WebappRender>
                        <div className="hire-card-neruda-step-five__pdf-viewer-container">
                            {pdfLink}
                            <br />
                            <div className="hire-card-open-credit-step-five__summary-label">
                                <FormattedText value="hireCardOpenCredit-infoLink" />
                            </div>
                            <br />
                            {PDFDcocument}
                            <br />
                        </div>
                    </WebappRender>
                    {agreementCheckboxContent}
                    <ContactCenterRender>
                        {showIneAndRevolving ?
                            legalConfirmationSection
                            : <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                        }
                    </ContactCenterRender>
                    {GDPRSignaturePatternContent}
                </article>
            );
        }

    }
}

HireCreditCardStep5.propTypes = {
    cardType: PropTypes.oneOf(['neruda', 'vanity']),
    contractName: PropTypes.string,
    getContextTranslate: PropTypes.func.isRequired,
    handleAgreementCheckboxChange: PropTypes.func.isRequired,
    immHireCardNameSelector: PropTypes.object.isRequired,
    hireCreditCard: PropTypes.object.isRequired,
    immHireCreditLimit: PropTypes.object.isRequired,
    immHirePaymentMethod: PropTypes.object.isRequired,
    immPdfData: PropTypes.object.isRequired,
    immPdfDownloadData: PropTypes.object,
    immProfile: PropTypes.object.isRequired,
    immShippingAddressList: PropTypes.object,
    operativeName: PropTypes.string,
    requestPDFDownload: PropTypes.func,
    sendMailParams: PropTypes.object,
    sendPrecontractualDocumentMail: PropTypes.func.isRequired,
    setTermsAndCondsText: PropTypes.func.isRequired,
    showIneAndRevolving: PropTypes.bool,
};

module.exports = HireCreditCardStep5;
